//
//
//
//
//
//
//
import doc from './md/doc.md';
export default {
  data: function data() {
    return {
      doc: doc
    };
  }
};